import { gql } from '@apollo/client';

export default gql`
  query Query($query: String!) {
    termsAutocomplete(query: $query) {
      term
      highlight
    }
  }
`;
